import { render } from "./RecordMinutes.vue?vue&type=template&id=0d259f40"
import script from "./RecordMinutes.vue?vue&type=script&lang=js"
export * from "./RecordMinutes.vue?vue&type=script&lang=js"

import "./RecordMinutes.vue?vue&type=style&index=0&id=0d259f40&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__